import { Box, Cup, P, Pendant, PersonStanding, Plant, Shadow } from "@/components/workspaces/IsoKit";

const Stool = ({ x, y }) => (
    <g>
        <ellipse cx={P(x, y, 20.5)[0]} cy={P(x, y, 20.5)[1]} rx={11} ry={4.5} fill="#16324F" opacity={0.1} />
        <line x1={P(x, y, 24)[0]} y1={P(x, y, 24)[1]} x2={P(x, y, 38)[0]} y2={P(x, y, 38)[1]} stroke="#5A688A" strokeWidth={2.4} />
        <Box x={x} y={y} w={18} d={18} z0={38} h={5} t="#E7CDA8" l="#C9A87F" r="#B8946C" />
    </g>
);

export const CoffeeBreakoutVisual = () => (
    <svg viewBox="0 0 640 480" className="h-full w-full" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Conceptual visualization of the Work Island coffee and breakout counter">
        <Shadow x={0} y={0} rx={110} ry={30} />
        <Stool x={-40} y={55} />
        <Stool x={10} y={60} />
        <Stool x={60} y={55} />
        <PersonStanding x={-78} y={-38} color="#3E4C66" />
        <Box x={0} y={0} w={150} d={40} z0={20} h={44} t="#E7CDA8" l="#C9A87F" r="#B8946C" stroke="#D9BC93" />
        <Box x={-52} y={-8} w={24} d={18} z0={64} h={20} t="#5B6B8C" l="#4A5878" r="#3F4D6C" />
        <Cup x={10} y={-6} z={64} />
        <Cup x={28} y={8} z={64} />
        <Cup x={48} y={-4} z={64} />
        <Plant x={-145} y={-70} s={0.9} />
        <Plant x={150} y={60} s={0.8} />
        <Pendant x={-30} y={0} />
        <Pendant x={30} y={0} />
    </svg>
);

export const ReceptionVisual = () => (
    <svg viewBox="0 0 640 480" className="h-full w-full" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Conceptual visualization of the Work Island reception and common area">
        <Shadow x={0} y={10} rx={120} ry={32} />
        <Box x={-140} y={-60} w={22} d={60} z0={20} h={80} t="#FBFCFE" l="#E9ECF3" r="#DDE1EC" stroke="#D5DAE6" />
        {[50, 74].map((sz) => (
            <line key={sz} x1={P(-129, -84, sz)[0]} y1={P(-129, -84, sz)[1]} x2={P(-129, -36, sz)[0]} y2={P(-129, -36, sz)[1]} stroke="#D5DAE6" strokeWidth={1} />
        ))}
        <PersonStanding x={62} y={-32} color="#33415C" />
        <Box x={0} y={10} w={170} d={36} z0={20} h={46} t="#E7CDA8" l="#E9ECF3" r="#DDE1EC" stroke="#D5DAE6" />
        <circle cx={P(0, 28.5, 44)[0]} cy={P(0, 28.5, 44)[1]} r={5.5} fill="#2B5CAB" opacity={0.75} />
        <Cup x={-40} y={4} z={66} />
        <Plant x={140} y={-70} s={0.9} />
        <Plant x={-150} y={60} s={0.8} />
        <Pendant x={0} y={10} />
    </svg>
);
